// Pure helpers for the FINTRAC program screen (tested in fintrac.test.js).

export const STATE_TEXT = { in_place: 'In place', needs_update: 'Needs attention', due: 'Due', missing: 'Not set up' };

export const ENTITY_TYPES = [
  { key: 'corporation', label: 'Corporation' },
  { key: 'trust', label: 'Trust' },
  { key: 'partnership', label: 'Partnership' },
  { key: 'other_entity', label: 'Other entity' },
];

// Which form an element's action opens.
export function dialogFor(el) {
  if (!el) return null;
  if (el.key === 'training') return el.action === 'Record plan' ? 'plan' : 'training';
  return el.key;
}

export function fmtDay(d) {
  if (!d) return '';
  const dt = new Date(`${String(d).slice(0, 10)}T12:00:00`);
  return Number.isNaN(dt.getTime()) ? String(d) : dt.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
}

// Replace ISO dates inside server copy with readable ones ("Due 2027-01-01" → "Due Jan 1, 2027").
export function readable(s) {
  return s ? String(s).replace(/\b(\d{4}-\d{2}-\d{2})\b/g, (m) => fmtDay(m)) : s;
}

export function fintracStats(data) {
  const s = data?.stats || {};
  return [
    { label: 'Program parts in place', value: `${s.in_place || 0} of ${s.elements || 5}`, attention: (s.in_place || 0) < (s.elements || 5) },
    { label: 'Trained in the last year', value: `${s.trained || 0} of ${s.people || 0}`, attention: (s.trained || 0) < (s.people || 0) },
    { label: 'Next effectiveness review', value: s.review_due ? fmtDay(s.review_due) : 'None on file', attention: !s.review_due },
  ];
}

// Owner rows from the form: drop blanks, keep numbers as numbers.
export function cleanOwners(rows) {
  return (rows || [])
    .filter((r) => String(r.name || '').trim())
    .map((r) => ({ name: r.name.trim(), address: String(r.address || '').trim() || null, percent: Number(r.percent) }));
}

export function ownersError(rows) {
  const list = cleanOwners(rows);
  if (list.some((o) => !Number.isFinite(o.percent) || o.percent <= 0 || o.percent > 100)) return 'Each owner needs a percentage between 0 and 100.';
  if (list.reduce((a, o) => a + o.percent, 0) > 100.001) return 'Ownership adds up to more than 100%.';
  return '';
}

export function todayIso(now = new Date()) {
  const y = now.getFullYear(), m = String(now.getMonth() + 1).padStart(2, '0'), d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
